import { html } from "lit";
import { renderStandardPictureElement } from "../../../../utils";
// import { simpleBoxesTemplate } from "../../01-website/modules/highlights.stories.mdx";

export const ueberblickTab = () => html`
    <div class="row">
        <div
            class="gr-10 push-1 u-textCenter gr-10@t push-1@t gr-12@m push-0@m u-marginBottom-60 u-headline-inModule"
        >
            <h3
                class="headline-small"
                data-gtm-vis-first-on-screen-8366999_129="7070"
                data-gtm-vis-total-visible-time-8366999_129="1000"
                data-gtm-vis-has-fired-8366999_129="1"
            >
                Ideale Sicht für präzises Schneiden
            </h3>
            <div class="text-normal u-color-gray-paragraph u-marginTop-em">
                <p>
                    Das kostengünstigste Modell ohne Spanabtrenner eignet sich
                    besonders für Schneidaufgaben ohne Spanabtrennung während
                    des Schneidvorgangs. So zum Beispiel wenn Sie gerade Bleche
                    ablängen oder bei Kurvenschnitten. Eine offene Sicht auf das
                    Werkstück ermöglicht Ihnen präzises Schneiden. Der Span
                    rollt definiert ab, Kratzer am Werkstück werden vermieden.
                    Die TruTool C 160 schneidet Blechdicken bis 1,6 mm Baustahl
                    und 1,2 mm Edelstahl.
                </p>
            </div>
        </div>
    </div>
`;

export const anwendungenTab = () => {
    return html` <div class="row">
        <div class="gr-12 no-gutter">
            <ux-slider arrows-follow-img>
                ${anwendungTabSlide()} ${anwendungTabSlide()}
                ${anwendungTabSlide()}
                <ux-slider-pagination slot="pagination" bottom-pagination>
                </ux-slider-pagination>
            </ux-slider>
        </div>
    </div>`;
};

export const lieferumfangTab = () => {
    return html`
        <div class="row">
            <div
                class="gr-8 push-2 gr-10@t push-1@t gr-12@m push-0@m u-marginBottom-30 u-textCenter"
            >
                <div class="text-normal u-color-gray-paragraph">
                    <p>
                        Die nachfolgenden Verbrauchsmaterialien und das
                        entsprechende Zubehör sind im Lieferumfang mit
                        enthalten.
                    </p>
                </div>
            </div>
        </div>
        <div class="row" data-sameheight="group" data-sameheight-top="182">
            <div
                class="gr-5 push-1 push-0@m push-1@t gr-10@t gr-12@m u-marginBottom-30"
            >
                <div class="block u-shadow">
                    <div class="block-image">
                        ${renderStandardPictureElement({
                            width: 1200,
                            height: 800,
                        })}
                    </div>
                    <div
                        class="block-content"
                        data-sameheight="item"
                        data-sameheight-top="275"
                        style="height: 228px;"
                    >
                        <div class="left-green-square">
                            <div class="title-normal-bold">
                                Messer Gerade (eingebaut)
                            </div>
                        </div>
                        <div class="block-content-text u-color-gray-paragraph">
                            <div class="text-normal ">
                                <p>1 - 1,6 mm</p>
                            </div>
                        </div>
                        <div
                            class="block-button u-textCenter u-marginTop-30"
                        ></div>
                    </div>
                </div>
            </div>
            <div
                class="gr-5 push-1 push-0@m push-1@t gr-10@t gr-12@m u-marginBottom-30"
            >
                <div class="block u-shadow">
                    <div class="block-image">
                        ${renderStandardPictureElement({
                            width: 1200,
                            height: 800,
                        })}
                    </div>
                    <div
                        class="block-content"
                        data-sameheight="item"
                        data-sameheight-top="275"
                        style="height: 228px;"
                    >
                        <div class="left-green-square">
                            <div class="title-normal-bold">
                                Schneidleistensatz, 2 Stück mit Schrauben
                                (eingebaut)
                            </div>
                        </div>
                        <div class="block-content-text u-color-gray-paragraph">
                            <div class="text-normal ">
                                <p>1 Stück 0927708</p>
                            </div>
                        </div>
                        <div
                            class="block-button u-textCenter u-marginTop-30"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    `;
};

export const zubehoerTab = () => {
    return html`
        <div class="row">
    <div class="gr-8 push-2 gr-10@t push-1@t gr-12@m push-0@m u-marginBottom-30 u-textCenter">
        <div class="text-normal u-color-gray-paragraph">
            <p>
                Die nachfolgenden Verbrauchsmaterialien und das
                entsprechende Zubehör sind im Lieferumfang mit
                enthalten.
            </p>
        </div>
    </div>
</div>
<div class="row">
    <div class="gr-10 push-1 no-gutter" data-sameheight="group" data-sameheight-top="154">
        <div class="gr-4 gr-12@m ux-u-margin-bottom-30">
            <div class="block u-shadow" data-sameheight="item" data-sameheight-top="0" style="height: 371.953px;">
                <div class="block-image">
                   ${renderStandardPictureElement({
                       width: 400,
                       height: 150,
                   })}
                </div>
                <div class="block-content">
                    <div class="text-tiny u-uppercase u-block"><strong>Messer Gerade 1 - 1,6 mm
                        </strong></div>
                    <div class="block-content-text">
                        <div class="text-normal ">
                            <p>Optimal für Blechdicken 1 - 1,6 mm
                            </p>
                        </div>
                    </div>
                    <div class="block-content-text u-color-gray-paragraph"><span class="text-normal">
                            2er-Set&nbsp;
                        </span><span class="text-normal">
                            1264343
                        </span></div>
                    <div class="block-content-text u-color-gray-paragraph"><span class="text-normal">
                            5er-Set&nbsp;
                        </span><span class="text-normal">
                            1264345
                        </span></div>
                </div>
            </div>
        </div>
        <div class="gr-4 gr-12@m ux-u-margin-bottom-30">
            <div class="block u-shadow" data-sameheight="item" data-sameheight-top="0" style="height: 371.953px;">
                <div class="block-image">
                  ${renderStandardPictureElement({
                      width: 400,
                      height: 150,
                  })}
                </div>
                <div class="block-content">
                    <div class="text-tiny u-uppercase u-block"><strong>Messer Gerade bis 1 mm
                        </strong></div>
                    <div class="block-content-text">
                        <div class="text-normal ">
                            <p>Optimal für Blechdicken bis 1 mm
                            </p>
                        </div>
                    </div>
                    <div class="block-content-text u-color-gray-paragraph"><span class="text-normal">
                            2er-Set&nbsp;
                        </span><span class="text-normal">
                            1264356
                        </span></div>
                    <div class="block-content-text u-color-gray-paragraph"><span class="text-normal">
                            5er-Set&nbsp;
                        </span><span class="text-normal">
                            1264357
                        </span></div>
                </div>
            </div>
        </div>
        <div class="gr-4 gr-12@m ux-u-margin-bottom-30">
            <div class="block u-shadow" data-sameheight="item" data-sameheight-top="0" style="height: 371.953px;">
                <div class="block-image">
                  ${renderStandardPictureElement({
                      width: 400,
                      height: 150,
                  })}
                </div>
                <div class="block-content">
                    <div class="text-tiny u-uppercase u-block"><strong>Kurvenmesser
                        </strong></div>
                    <div class="block-content-text">
                        <div class="text-normal ">
                            <p>Gute Kurvengängigkeit. Für Blechdicken bis 1 mm.
                            </p>
                        </div>
                    </div>
                    <div class="block-content-text u-color-gray-paragraph"><span class="text-normal">
                            2er-Set&nbsp;
                        </span><span class="text-normal">
                            1264358
                        </span></div>
                    <div class="block-content-text u-color-gray-paragraph"><span class="text-normal">
                            5er-Set&nbsp;
                        </span><span class="text-normal">
                            1264359
                        </span></div>
                </div>
            </div>
        </div>
        <div class="gr-4 gr-12@m ux-u-margin-bottom-30">
            <div class="block u-shadow" data-sameheight="item" data-sameheight-top="402" style="height: 371.953px;">
                <div class="block-image">
                    ${renderStandardPictureElement({
                        width: 400,
                        height: 150,
                    })}
                </div>
                <div class="block-content">
                    <div class="text-tiny u-uppercase u-block"><strong>Messer CR
                        </strong></div>
                    <div class="block-content-text">
                        <div class="text-normal ">
                            <p>Optimal für Edelstahl und Wickelfalzrohre
                            </p>
                        </div>
                    </div>
                    <div class="block-content-text u-color-gray-paragraph"><span class="text-normal">
                            2er-Set&nbsp;
                        </span><span class="text-normal">
                            1264346
                        </span></div>
                    <div class="block-content-text u-color-gray-paragraph"><span class="text-normal">
                            5er-Set&nbsp;
                        </span><span class="text-normal">
                            1264347
                        </span></div>
                </div>
            </div>
        </div>
        <div class="gr-4 gr-12@m ux-u-margin-bottom-30">
            <div class="block u-shadow" data-sameheight="item" data-sameheight-top="402" style="height: 371.953px;">
                <div class="block-image">
                    ${renderStandardPictureElement({
                        width: 400,
                        height: 150,
                    })}
                </div>
                <div class="block-content">
                    <div class="text-tiny u-uppercase u-block"><strong>Messer-Set
                        </strong></div>
                    <div class="block-content-text">
                        <div class="text-normal ">
                            <p>1 x Messer Gerade 1 mm, 1 x Kurvenmesser</p>
                            </p>
                        </div>
                    </div>
                    <div class="block-content-text u-color-gray-paragraph"><span class="text-normal">
                            1er-Set&nbsp;
                        </span><span class="text-normal">
                            913521
                        </span></div>
                </div>
            </div>
        </div>
        <div class="gr-4 gr-12@m ux-u-margin-bottom-30">
            <div class="block u-shadow" data-sameheight="item" data-sameheight-top="402" style="height: 371.953px;">
                <div class="block-image">
                      ${renderStandardPictureElement({
                          width: 400,
                          height: 150,
                      })}
                </div>
                <div class="block-content">
                    <div class="text-tiny u-uppercase u-block"><strong>Schneidleistensatz
                        </strong></div>
                    <div class="block-content-text">
                        <div class="text-normal ">
                            <p>2 Stück mit Schrauben
                            </p>
                        </div>
                    </div>
                    <div class="block-content-text u-color-gray-paragraph"><span class="text-normal">
                            1er-Set&nbsp;
                        </span><span class="text-normal">
                            927708
                        </span></div>
                </div>
            </div>
        </div>
        <div class="gr-4 gr-12@m ux-u-margin-bottom-30">
            <div class="block u-shadow" data-sameheight="item" data-sameheight-top="804" style="height: 332.953px;">
                <div class="block-image">
                      ${renderStandardPictureElement({
                          width: 400,
                          height: 150,
                      })}
                </div>
                <div class="block-content">
                    <div class="text-tiny u-uppercase u-block"><strong>Schmierfett G1
                        </strong></div>
                    <div class="block-content-text">
                        <div class="text-normal ">
                            <p></p>
                        </div>
                    </div>
                    <div class="block-content-text u-color-gray-paragraph"><span class="text-normal">
                            25 g&nbsp;
                        </span><span class="text-normal">
                            344969
                        </span></div>
                    <div class="block-content-text u-color-gray-paragraph"><span class="text-normal">
                            250 g&nbsp;
                        </span><span class="text-normal">
                            1446686
                        </span></div>
                    <div class="block-content-text u-color-gray-paragraph"><span class="text-normal">
                            900 g&nbsp;
                        </span><span class="text-normal">
                            139440
                        </span></div>
                </div>
            </div>
        </div>
        <div class="gr-4 gr-12@m ux-u-margin-bottom-30">
            <div class="block u-shadow" data-sameheight="item" data-sameheight-top="804" style="height: 332.953px;">
                <div class="block-image">
                     ${renderStandardPictureElement({
                         width: 400,
                         height: 150,
                     })}
                </div>
                <div class="block-content">
                    <div class="text-tiny u-uppercase u-block"><strong>TRUMPF Box S1
                        </strong></div>
                    <div class="block-content-text">
                        <div class="text-normal ">
                            <p></p>
                        </div>
                    </div>
                    <div class="block-content-text u-color-gray-paragraph"><span class="text-normal">
                            1 Stück&nbsp;
                        </span><span class="text-normal">
                            1763681
                        </span></div>
                </div>
            </div>
        </div>
    </div>
</div>
    `;
};

export const technischeDatenTab = () => {
    return html`
        <div class="row" xmlns:f="http://www.w3.org/1999/html">
            <div class="gr-10 push-1 push-0@m push-1@t gr-10@t gr-12@m">
                <!-- Compare table simple -->
                <div class="gr-12 compare-box-wrapper">
                    <table class="compare-module-simple ">
                        <thead>
                            <tr>
                                <th class="first"></th>
                                <th>
                                    <div class="title-normal-bold">
                                        TruTool C 160
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- category -->
                            <tr class="cat even">
                                <td class="first">
                                    Maximale Blechdicken
                                </td>
                                <td>&nbsp;</td>
                            </tr>
                            <!-- sub category -->
                            <tr class="sub-cat even">
                                <td class="first">
                                    Maximale Blechdicke Stahl 400 N/mm²
                                </td>
                                <td>
                                    1,6 mm
                                </td>
                            </tr>
                            <!-- sub category -->
                            <tr class="sub-cat even">
                                <td class="first">
                                    Maximale Blechdicke Stahl 600 N/mm²
                                </td>
                                <td>
                                    1,2 mm
                                </td>
                            </tr>
                            <!-- sub category -->
                            <tr class="sub-cat even">
                                <td class="first">
                                    Maximale Blechdicke Aluminium bis 250 N/mm²
                                </td>
                                <td>
                                    2 mm
                                </td>
                            </tr>
                            <!-- category -->
                            <tr class="cat odd">
                                <td class="first">
                                    Radien
                                </td>
                                <td>&nbsp;</td>
                            </tr>
                            <!-- sub category -->
                            <tr class="sub-cat odd">
                                <td class="first">
                                    Kleinster Radius
                                </td>
                                <td>
                                    40 mm
                                </td>
                            </tr>
                            <!-- category -->
                            <tr class="cat even">
                                <td class="first">
                                    Allgemein
                                </td>
                                <td>&nbsp;</td>
                            </tr>
                            <!-- sub category -->
                            <tr class="sub-cat even">
                                <td class="first">
                                    Arbeitsgeschwindigkeit
                                </td>
                                <td>
                                    6 m/min - 10 m/min
                                </td>
                            </tr>
                            <!-- sub category -->
                            <tr class="sub-cat even">
                                <td class="first">
                                    Hubzahl bei Nennlast
                                </td>
                                <td>
                                    3800 1/min
                                </td>
                            </tr>
                            <!-- sub category -->
                            <tr class="sub-cat even">
                                <td class="first">
                                    Startlochdurchmesser
                                </td>
                                <td>
                                    15 mm
                                </td>
                            </tr>
                            <!-- sub category -->
                            <tr class="sub-cat even">
                                <td class="first">
                                    Nennaufnahmeleistung
                                </td>
                                <td>
                                    350 W
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    `;
};

export const anwendungTabSlide = () => html`
    <ux-slider-slide>
        <div class="gr-10 push-1 gr-12@m push-0@m">
            ${renderStandardPictureElement({
                width: 1200,
                height: 800,
            })}
            <div class="gr-10 push-1">
                <h2 class="headline-small">
                    Flachblech
                </h2>
                <div class="text-normal ">
                    <p>
                        Zum Trennen und Besäumen von geraden Blechen. Für
                        Radial- und Innenausschnitte sowie Ausklinkungen.
                    </p>
                </div>
            </div>
        </div>
    </ux-slider-slide>
`;
